import React from 'react'
import { BsGithub } from "react-icons/bs";
import { FaGlobe } from "react-icons/fa";
import { useTheme } from '../theme/ThemeContext';

const ProjectsCard = ({ title, des, src, githubUrl, hostLink }) => {
  const {darkTheme} = useTheme();
  return (
    <div className={darkTheme?"w-full p-4 xl:px-12 h-auto xl:py-10 rounded-lg  flex flex-col bg-gradient-to-r from-bodyColor to-[gray]  group hover:bg-gradient-to-b hover:from-bodyColor-900 hover:gray-900 transition-colors duration-1000"
  :"w-full p-4 xl:px-12 h-auto xl:py-10 rounded-lg  flex flex-col bg-gradient-to-r from-grayBodyColor to-[gray]  group hover:bg-gradient-to-b hover:from-bodyColor-900 hover:gray-900 transition-colors duration-1000"}>
      <div className="w-full h-[80%] overflow-hidden rounded-lg">
        <img
          className="w-full h-60 object-cover group-hover:scale-110 duration-300 cursor-pointer"
          src={src}
          alt="src"
        />
      </div>
      <div className="w-full mt-5 flex flex-col  gap-6">
        <div>
          <div className="flex items-center justify-between">
            <h3 className={darkTheme?"text-base uppercase text-black font-normal"
            :"text-base uppercase text-black font-normal"}>
              {title}
            </h3>
            <div className="flex gap-2">
              <span className={darkTheme?"text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer":
                "text-lg w-10 h-10 rounded-full bg-white inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer"}>
              <a href={githubUrl}>
              <BsGithub />
            </a>
              </span>

              <span className={darkTheme?"text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer":
                "text-lg w-10 h-10 rounded-full bg-white inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer"}>
               <a href={hostLink}>
                <FaGlobe />
                </a>
              </span>
            </div>
          </div>
          <p className={darkTheme?"text-white tracking-wide mt-3 hover:text-gray-100 duration-300":
          "text-black tracking-wide mt-3 hover:text-black-100 duration-300"}>
            {des}
          </p>
        </div>
      </div>
    </div>
  );
}

export default ProjectsCard